import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";
import MangaCard from "@/components/feature/MangaCard";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import NewsSection from "./components/NewsSection";
import { mangaList } from "@/mocks/manga";
import { faqItems } from "@/mocks/content";

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const featured = mangaList.filter((m) => m.isFeatured);
  const hotList = [...mangaList].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const latest = mangaList.slice(0, 8);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "《满溢游泳池》漫画-免费阅读漫画全集-178漫画网",
      url: "https://swimchats.github.io/",
      description: "在178漫画网免费阅读《满溢游泳池》漫画全集，在线浏览全集中文故事，无需付费即可享受完整章节和高清画面。",
      breadcrumb: { "@type": "BreadcrumbList", itemListElement: [{ "@type": "ListItem", position: 1, name: "首页", item: "https://swimchats.github.io/" }] },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title="《满溢游泳池》漫画-免费阅读漫画全集-178漫画网"
        description="在178漫画网免费阅读《满溢游泳池》漫画全集，在线浏览全集中文故事，无需付费即可享受完整章节和高清画面。满溢游泳池漫画,免费阅读,漫画全集,178漫画网。"
        keywords="满溢游泳池漫画,免费阅读,漫画全集,178漫画网"
        canonical="https://swimchats.github.io/"
        jsonLd={jsonLd}
      />
      <Navbar isHome />
      <main>
        <Hero />
        <CategoryGrid />

        <section className="mx-auto max-w-7xl px-4 md:px-6 pb-12 md:pb-16">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
            <div className="lg:col-span-2">
              <div className="flex items-end justify-between">
                <div>
                  <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">最新章节</h2>
                  <p className="mt-2 text-sm text-foreground-600">追更不迷路，最新话抢先看</p>
                </div>
                <span className="hidden items-center gap-1 text-sm text-primary-600 sm:inline-flex">
                  <i className="ri-refresh-line"></i>实时更新
                </span>
              </div>
              <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                {latest.map((m) => (
                  <MangaCard key={m.id} manga={m} />
                ))}
              </div>
            </div>

            <div>
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-fire-line"></i>
                </span>
                <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">人气榜单</h2>
              </div>
              <p className="mt-2 text-sm text-foreground-600">本周最受欢迎的漫画</p>
              <ol className="mt-6 flex flex-col gap-3">
                {hotList.map((m, i) => (
                  <li key={m.id}>
                    <Link
                      to={`/article/${m.slug}`}
                      className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200"
                    >
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-base ${
                          i === 0 ? "bg-primary-500 text-background-50" : i === 1 ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                        }`}
                      >
                        {i + 1}
                      </span>
                      <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-100">
                        <img src={m.cover} alt={`${m.title} 漫画封面`} className="h-full w-full object-cover object-top" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">{m.title}</p>
                        <p className="mt-1 truncate text-xs text-foreground-500">
                          {m.categoryName} · {m.chapters}话 · {m.views}阅读
                        </p>
                      </div>
                      <span className="shrink-0 text-xs text-accent-600">{m.rating.toFixed(1)}分</span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </section>

        <section className="border-y border-background-200 bg-background-100">
          <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
            <div className="flex items-end justify-between">
              <div>
                <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">编辑推荐</h2>
                <p className="mt-2 text-sm text-foreground-600">编辑部私藏的宝藏漫画</p>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2">
              {featured.map((m) => (
                <Link
                  key={m.id}
                  to={`/article/${m.slug}`}
                  className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 sm:flex-row sm:items-center"
                >
                  <div className="h-44 w-full shrink-0 overflow-hidden rounded-md bg-background-100 sm:h-36 sm:w-28">
                    <img
                      src={m.cover}
                      alt={`${m.title} 漫画封面`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="rounded-md bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700">编辑精选</span>
                      <span className="text-xs text-foreground-400">{m.status}</span>
                    </div>
                    <h3 className="mt-2 font-heading text-lg text-foreground-950 group-hover:text-primary-600">{m.title}</h3>
                    <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{m.synopsis}</p>
                    <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1"><i className="ri-star-fill text-accent-500"></i>{m.rating.toFixed(1)}</span>
                      <span>{m.chapters}话</span>
                      <span>{m.author}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <NewsSection />

        <section className="mx-auto max-w-4xl px-4 md:px-6 py-12 md:py-16">
          <div className="text-center">
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">常见问题</h2>
            <p className="mt-2 text-sm text-foreground-600">关于免费阅读的常见疑问解答</p>
          </div>
          <div className="mt-8 flex flex-col gap-3">
            {faqItems.map((f, i) => {
              const open = openFaq === i;
              return (
                <div key={i} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                  <button
                    onClick={() => setOpenFaq(open ? null : i)}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    aria-expanded={open}
                  >
                    <span className="text-sm font-semibold text-foreground-950">{f.q}</span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-transform ${open ? "rotate-45" : ""}`}>
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {open && (
                    <div className="border-t border-background-100 px-5 py-4 text-sm leading-6 text-foreground-600">{f.a}</div>
                  )}
                </div>
              );
            })}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}